import * as R from 'Router/routes';
import { isProductKind } from 'utils/getProductNumber';
import { memo } from 'react';
import { PRODUCT_NUMBER_IL } from 'utils/constants';
import { useLatestLoan } from 'hooks/webapi';
import { useLocation } from 'react-router-dom';
import { usePhone } from 'hooks/usePhone';
import { useTranslation } from 'react-i18next';
import ArrowIcon from 'assets/icons/arrow-full-right.svg?react';
import ChatIcon from 'assets/icons/chat-v2.svg?react';
import classes from 'classnames';
import FooterCookieAccessibility from 'components/FooterCookieAccessibility/FooterCookieAccessibility';
import Link from 'components/Link/Link';
import styles from './FooterOverdue.module.scss';

export type Props = {
  className?: string;
  dataTest?: string;
};

export default memo(function FooterOverdue({
  className,
  dataTest = 'footerOverdue',
}: Props) {
  const { t } = useTranslation('footerOverdue');
  const { latestLoan } = useLatestLoan();
  const { pathname } = useLocation();

  const { phone } = usePhone();

  const isCons7 = isProductKind(latestLoan, PRODUCT_NUMBER_IL);

  const showPayLink =
    isCons7 &&
    [R.INSTALLMENT_PAYMENT, R.DR_PAYMENT_SCHEDULE].includes(pathname);

  const footerLinkRoute = `${R.FULL_REPAYMENT}?backRoute=${pathname}`;

  return (
    <div className={styles['footer-wrapper']}>
      <footer
        data-test={dataTest}
        className={classes(styles.footer, className)}
      >
        <ChatIcon data-test={`${dataTest}-chat-icon`} />
        <span className={styles.title} data-test={`${dataTest}-title`}>
          {t('title')}
        </span>
        <span className={styles['email-phone']} data-test={`${dataTest}-email`}>
          {t('email')}
        </span>
        <span className={styles['email-phone']} data-test={`${dataTest}-phone`}>
          {phone}
        </span>
        <span
          className={styles['work-hours']}
          data-test={`${dataTest}-work-hours`}
        >
          {t('work_hours_weekdays')}
        </span>
        <span
          className={styles['work-hours']}
          data-test={`${dataTest}-work-hours-weekend`}
        >
          {t('work_hours_weekends')}
        </span>
        {showPayLink && (
          <Link
            className={styles['pay-link']}
            to={footerLinkRoute}
            dataTest={`${dataTest}-link`}
          >
            <ArrowIcon />
            <span>{t('pay_full_loan')}</span>
          </Link>
        )}
        <FooterCookieAccessibility />
      </footer>
    </div>
  );
});
